import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isUpdateInvitationGroupPanelOpenSelector,
  setIsUpdateInvitationGroupPanelOpen,
  updateInvitationGroup,
} from '../../../../../../../features/pageFeatures/invitationGroupAdministrationPageSlice';
import {
  getAttr,
  getEntityId,
} from '../../../../../../../features/helpers/apiHelpers';

export const useUpdateInvitationGroup = (
  invitationGroups,
  selectedInvitationGroupKey,
) => {
  const dispatch = useDispatch();
  const [title, setTitle] = useState();

  useEffect(() => {
    const invitationGroup = invitationGroups.find(
      (invitationGroup) =>
        getEntityId(invitationGroup) === selectedInvitationGroupKey,
    );
    if (invitationGroup) {
      const title = getAttr(invitationGroup, 'name');
      setTitle(title);
    }
  }, [invitationGroups, selectedInvitationGroupKey]);

  const isPanelOpen = useSelector(isUpdateInvitationGroupPanelOpenSelector);

  function onPanelClose() {
    dispatch(setIsUpdateInvitationGroupPanelOpen(false));
    setTitle();
  }

  function onConfirm() {
    dispatch(
      updateInvitationGroup({
        title,
        invitationGroupId: selectedInvitationGroupKey,
      }),
    );
  }

  return {
    title,
    setTitle,
    isPanelOpen,
    onPanelClose,
    onConfirm,
  };
};
